export default "__VITE_ASSET__f5240efa__"